module.exports = __webpack_public_path__ + "static/media/feature-regular-basis-offer.cab76df4.png";